export default function Order() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.525 3.5H19C19.2652 3.5 19.5196 3.60536 19.7071 3.79289C19.8946 3.98043 20 4.23478 20 4.5V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V4.5C4 4.23478 4.10536 3.98043 4.29289 3.79289C4.48043 3.60536 4.73478 3.5 5 3.5H8.5V5H15.5V3.5H16.525Z'
        stroke='#666666'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M13.5 9.5L9.5 13.5005H14.502L10.5 17.5005M8.5 2H15.5V5H8.5V2Z'
        stroke='#666666'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
